import tidalTransitionExpand from './components/tidal-transition-expand.vue';

export {
    tidalTransitionExpand,
};
